// extracted by mini-css-extract-plugin
export default {"currencyIcon":"MakedProfitNotify_currencyIcon__xTLOQ"};